import React, { useEffect, useState, useRef } from "react"
import { Link, useParams } from "react-router-dom"
import Select from "react-select"
import Flatpickr from "react-flatpickr"
import "flatpickr/dist/themes/material_blue.css"
import SignatureCanvas from "react-signature-canvas";
import Webcam from "react-webcam"
import { addLab, getJob, getLab, getPatient, getvision, getVisionType, labordernumber } from "../../service/api"
import { toast } from "react-toastify"

import {
    Card,
    Col,
    Container,
    Row,
    CardBody,
    CardTitle,
    Label,
    Button,
    Form,
    Input,
    InputGroup,
    Table,
    CardSubtitle,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,

} from "reactstrap"

const defaultValue = {
    // vc_reference: "",
    patient_name: "",
    patient_id: "",
    date: "",
    patient: "",
    practisc_name: "",
    delivery_date: "",
    order_no: "",
    payment_details: "",
    delivery_info: "",
    order_type: "",
    frame: "",
    frame_color: "",
    frame_size: "",
    frame_material: "",
    frame_type: "",
    frame_shape: "",
    frame_brand: "",
    od_spere: "",
    od_cyl: "",
    od_axis: "",
    od_add: "",
    od_seg_height: "",
    os_spere: "",
    os_cyl: "",
    os_axis: "",
    os_add: "",
    os_seg_height: "",
    pd: "",
    two_pd_number: "",
    pd_left: "",
    pd_right: "",
    lens_material: "",
    lens_tint: "",
    lens_vision: "",
    lens_subvision: "",
    lens_type: "",
    add_prism: "",
    od_vertical: "",
    od_vb_direction: "",
    od_horizontal: "",
    od_hb_direction: "",
    os_vertical: "",
    os_vb_direction: "",
    os_horizontal: "",
    os_hb_direction: "",
    pre_od_sphere: "",
    pre_od_cyl: "",
    pre_od_axis: "",
    pre_od_aad: "",
    pre_od_segheight: "",
    pre_os_sphere: "",
    pre_os_cyl: "",
    pre_os_axis: "",
    pre_os_aad: "",
    pre_os_segheight: "",
    pre_pd: "",
    pre_pd_left: "",
    pre_pd_right: "",
    authorized_by: "",
    practice_name: "",
    px_number: "",
    additional_notes: "",
    total: "",
}

const Onlineorder = () => {


    const [modalOpen, setModalOpen] = useState(false);
    const [modalOpen1, setModalOpen1] = useState(false);
    const [modalOpen2, setModalOpen2] = useState(false);
    const [modalOpen3, setModalOpen3] = useState(false);
    const [activeInput, setActiveInput] = useState(null);
    const [activeInput1, setActiveInput1] = useState(null);
    const [activeInput2, setActiveInput2] = useState(null);
    const [activeInput3, setActiveInput3] = useState(null);
    const [selectedVision, setSelectedVision] = useState(null);
    const [Labordernumber, setlabordernumber] = useState({});
    const [Labordernumberview, setLabordernumberview] = useState([]);
    const [selectedFile, setSelectedFile] = useState(null);
    const [filteredOptions, setFilteredOptions] = useState([]);
    const [filteredOptionsvisionType, setFilteredOptionsvisionType] = useState([]);
    const todayDate = new Date().toISOString().split('T')[0];
    const [addData, setAddData] = useState({
        ...defaultValue,
        date: todayDate,
    });
    const [signatureRef, setSignatureRef] = useState(null);
    const [alluserlist, setallusers] = useState({ users: [] })
    const [vision, setallvision] = useState({ users: [] })
    const [visionType, setallvisionType] = useState({ users: [] })
    const [responseData, setResponseData] = React.useState([]);
    const [totals, setTotals] = useState({
        Hard: 0,
        HMC: 0,
        Uncoated: 0,
        ARC: 0,
        Blue: 0,
    });

    const [selectedTotal, setSelectedTotal] = useState(0);
    // const [imageSrc, setImageSrc] = useState("")
    const { id } = useParams();
    const [isLabToSupply, setIsLabToSupply] = useState(false);

    useEffect(() => {
        console.log("Response Data:", visionType);
        console.log("Filtered Options Vision Type:", filteredOptionsvisionType);
    }, [visionType, filteredOptionsvisionType]);


    const onValueChange = (e) => {
        const { name, value } = e.target;

        setAddData((prevData) => {
            const updatedData = { ...prevData, [name]: value };

            if (name === "lens_subvision") {
                if (filteredOptionsvisionType && filteredOptionsvisionType.length > 0) {
                    const selectedOption = filteredOptionsvisionType.find(
                        (user) => user._id === value
                    );
                    updatedData.lens_vision_type = selectedOption?.vision_type || "N/A";

                    if (selectedOption) {
                        console.log("Selected Vision Type ID:", selectedOption._id);
                        console.log("Hard:", selectedOption.hard);
                        console.log("HMC:", selectedOption.hmc);
                        console.log("Uncoated:", selectedOption.uncoated);
                        console.log("ARC Blue:", selectedOption.arc_blue);

                        setTotals({
                            Hard: selectedOption.hard ?? 0,
                            HMC: selectedOption.hmc ?? 0,
                            Uncoated: selectedOption.uncoated ?? 0,
                            ARC: selectedOption.arc_blue ?? 0,
                            Blue: selectedOption.arc_blue ?? 0,
                        });
                    } else {
                        console.log("No matching vision type found for lens_subvision:", value);
                    }
                } else {
                    console.log("filteredOptionsvisionType is empty or not loaded yet.");
                }
            }

            if (name === "lens_type") {
                // Ensure selectedTotal is set as a number, not an array
                const totalValue = totals[value] || 0;
                setSelectedTotal(totalValue);
            }

            return updatedData;
        });

        if (name === "frame") {
            setIsLabToSupply(value === "Lab To Supply");
        }
    };
    const clearSignature = () => {
        signatureRef.clear();
    };

    const saveSignature = () => {
        // Handle saving the signature image or data if needed
        console.log("Signature saved:", signatureRef.toDataURL("image/png"));
    };

    const handleInputClick = inputName => {
        setActiveInput(inputName);
        setModalOpen(true);
    };
    const handleInputClick1 = inputName => {
        setActiveInput1(inputName);
        setModalOpen1(true);
    };
    const handleInputClick2 = inputName => {
        setActiveInput2(inputName);
        setModalOpen2(true);
    };
    const handleInputClick3 = inputName => {
        setActiveInput3(inputName);
        setModalOpen3(true);
    };

    const handleSelectValue = value => {
        setAddData({
            ...addData,
            [activeInput]: value,
        });
        setModalOpen(false);
    };
    const handleSelectValue1 = value => {
        setAddData({
            ...addData,
            [activeInput1]: value,
        });
        setModalOpen1(false);
    };
    const handleSelectValue2 = value => {
        setAddData({
            ...addData,
            [activeInput2]: value,
        });
        `setModalOpen2`(false);
    };
    const handleSelectValue3 = value => {
        setAddData({
            ...addData,
            [activeInput3]: value,
        });
        setModalOpen3(false);
    };

    const renderDropdownOptions = () => {
        const options = [];
        for (let i = 1; i <= 100; i++) {
            options.push(
                <option key={i} value={i}>
                    {i}
                </option>
            );
        }
        return options;
    };

    const renderDropdownOptions1 = () => {
        const options = [];
        for (let i = 1; i <= 50; i++) {
            options.push(
                <option key={i} value={i}>
                    {i}
                </option>
            );
        }
        return options;
    };

    const fileInputRef = useRef(null);
    const handleClick = () => {
        fileInputRef.current.click();
    };

    const [isTwoPD, setIsTwoPD] = useState(false);

    const onCheckboxChange = e => {
        setIsTwoPD(e.target.checked);
    };

    useEffect(() => {
        getPatientAll();
        getVision();
        getVisiontype();
        getjobdata();
        getlabordernumber();
        getlabordernumberview();
        // getLabdata();
    }, [])


    const getPatientAll = async () => {
        try {
            let response = await getPatient()
            if (response.error) {
                console.log("Error while fetching data:", response.error)
            } else {
                setallusers({ users: response.data || [] })
            }
        } catch (error) {
            console.log("Error while fetching data:", error)
        }
    }

    const getVision = async () => {
        try {
            let response = await getvision()
            if (response.error) {
                console.log("Error while fetching data:", response.error)
            } else {
                setallvision({ users: response.data || [] })
            }
        } catch (error) {
            console.log("Error while fetching data:", error)
        }
    }

    const getVisiontype = async () => {
        try {
            const response = await getVisionType();
            if (response.error) {
                console.log("Error while fetching data:", response.error);
            } else {
                setallvisionType({ users: response.data || [] });
                console.log("Vision type data fetched:", response.data);
            }
        } catch (error) {
            console.log("Error while fetching vision type data:", error);
        }
    };


    const getlabordernumber = async () => {
        try {
            const response = await labordernumber();
            // Ensure it's not an array
            if (Array.isArray(response.data)) {
                setlabordernumber(response.data[0]);
            } else {
                setlabordernumber(response.data);
            }
        } catch (error) {
            console.error("Error fetching lab order number:", error);
        }
    };

    const getlabordernumberview = async () => {
        const response = await labordernumber();
        setLabordernumberview(response.data);
    }



    const [allvisit, setallvisit] = useState([]);
    const getjobdata = async () => {
        let response = await getJob();
        console.log("All job data:", response.data); // log all job data
        setallvisit(response.data);

        console.log("Incoming ID:", id); // log the id you are trying to match

        if (id) {
            const matchedJob = response.data.find((job) => job._id === id);
            console.log("Matched Job:", matchedJob); // check if a job was matched

            if (matchedJob) {
                console.log("Matched vc_reference number:", matchedJob.vc_reference);
                setAddData(prevData => ({
                    ...prevData,
                    jobId: matchedJob._id,
                    vc_reference: matchedJob.vc_reference,
                    practisc_name: matchedJob.practisc_name,
                    patient_name: matchedJob.patient_name,
                    patient_id: matchedJob._id,
                }));
            } else {
                console.warn("No matching job found for ID:", id);
            }
        } else {
            console.warn("No ID provided.");
        }
    };


    // const getjobdata = async () => {
    //     let response = await getJob();
    //     setallvisit(response.data);
    //     if (id) {
    //         const matchedJob = response.data.find((job) => job._id === id);
    //         if (matchedJob) {
    //             handlevisitChange({ value: matchedJob.vc_reference });
    //         }
    //     }
    // }
    const handlevisitChange = (selectedOption) => {
        const selectedConsignee = allvisit.find(patient => patient.vc_reference === selectedOption.value);
        if (selectedConsignee) {
            setAddData({
                ...addData,
                jobId: selectedConsignee._id,
                vc_reference: selectedConsignee.vc_reference,
                practisc_name: selectedConsignee.practisc_name,
                patient_name: selectedConsignee.patient_name,
                patient_id: selectedConsignee._id,
            });
        }
        console.log(addData);
    };

    const handleVisionChange = (e) => {
        const selectedVision = e.target.value;
        setSelectedVision(selectedVision);

        const matchedVision = vision.users.find((user) => user._id === selectedVision);

        const filteredTypes = visionType.users.filter((vt) => vt.vision._id === selectedVision);

        // Default to first filtered vision type if available
        const defaultSubVision = filteredTypes.length > 0 ? filteredTypes[0]._id : "";

        setAddData((prevData) => ({
            ...prevData,
            lens_vision_id: selectedVision,
            lens_vision_name: matchedVision ? matchedVision.vision : "",
            lens_subvision: defaultSubVision, // ✅ Auto-selecting first subvision
            lens_vision_type: filteredTypes.length > 0 ? filteredTypes[0].vision_type : "", // ✅ Optional
        }));

        setFilteredOptionsvisionType(filteredTypes);

        // Also update totals if applicable
        if (filteredTypes.length > 0) {
            const selectedOption = filteredTypes[0];
            setTotals({
                Hard: selectedOption.hard ?? 0,
                HMC: selectedOption.hmc ?? 0,
                Uncoated: selectedOption.uncoated ?? 0,
                ARC: selectedOption.arc_blue ?? 0,
                Blue: selectedOption.arc_blue ?? 0,
            });
        }
    };




    const handleClicks = () => {
        fileInputRef.current.click();
    };

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setSelectedFile(file);
        }
    };


    // const handleVisionChange = (e) => {
    //     const selectedVision = e.target.value;

    //     setSelectedVision(selectedVision); // Store selected vision ID
    //     const matchedVision = vision.users.find((user) => user._id === selectedVision);

    //     setAddData({
    //         ...addData,
    //         lens_vision_id: selectedVision,
    //         lens_vision_name: matchedVision ? matchedVision.vision : "",
    //     });

    //     // Dynamically filter the visionType
    //     const filteredTypes = visionType.users.filter((vt) => vt.vision._id === selectedVision);
    //     setFilteredOptionsvisionType(filteredTypes);
    // };
    // const handleSubmit = async e => {
    //     e.preventDefault();

    //     if (signatureRef.isEmpty()) {
    //         toast.error("Please sign before saving.");
    //         return;
    //     }

    //     try {
    //         const signatureImage = signatureRef.toDataURL("image/png");
    //         const formData = new FormData();

    //         const blob = await fetch(signatureImage).then(r => r.blob());
    //         formData.append("signature", blob, `signature_${Date.now()}.png`);

    //         Object.keys(addData).forEach(key => {
    //             formData.append(key, addData[key]);
    //         });

    //         formData.delete("total"); // Clear any existing 'total'
    //         formData.append("total", selectedTotal.toString());
    //         formData.delete("order_no");
    //         formData.append("order_no", Labordernumber?.order_no?.toString() || "");
    //         for (let pair of formData.entries()) {
    //             console.log(`${pair[0]}: ${pair[1]}`);
    //         }
    //         const response = await addLab(formData);
    //         console.log("Response:", response.data);
    //         toast.success("User saved successfully.", {
    //             position: "top-center",
    //             autoClose: 1500,
    //         });
    //     } catch (error) {
    //         console.error("Error saving user:", error);
    //         toast.error("Failed to save user. Check console for details.");
    //     }
    // };
    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const formData = new FormData();

            // Append signature only if it exists
            if (!signatureRef.isEmpty()) {
                const signatureImage = signatureRef.toDataURL("image/png");
                const blob = await fetch(signatureImage).then(r => r.blob());
                formData.append("signature", blob, `signature_${Date.now()}.png`);
            }

            // Append all other form data
            Object.keys(addData).forEach(key => {
                formData.append(key, addData[key]);
            });

            formData.delete("total"); // Clear any existing 'total'
            formData.append("total", selectedTotal.toString());
            formData.delete("order_no");
            formData.append("order_no", Labordernumber?.order_no?.toString() || "");

            for (let pair of formData.entries()) {
                console.log(`${pair[0]}: ${pair[1]}`);
            }

            const response = await addLab(formData);
            console.log("Response:", response.data);
            toast.success("User saved successfully.", {
                position: "top-center",
                autoClose: 1500,
            });
        } catch (error) {
            console.error("Error saving user:", error);
            toast.error("Failed to save user. Check console for details.");
        }
    };

    document.title = "Lab Order Form | optum";
    return (
        <React.Fragment>
            <div className="">
                <Container fluid>
                    <div className="d-flex justify-content-between align-items-center ">
                        {/* <CardTitle className="mb-4">ADD Patient</CardTitle> */}
                        <h4 className="page-title">Lab Order Form</h4>
                        {/* <Link to="/LabOrderList" className="btn btn-danger">
                            List
                        </Link> */}
                    </div>
                    <Row>
                        <Card>
                            <CardBody>
                                <Form>
                                    <Row>
                                        <Col md={3}>
                                            <div className="mb-3">
                                                <Label htmlFor="formrow-country-Input">vc_reference No.<span style={{ color: "red", fontWeight: "bolder" }}>*</span></Label>
                                                <Select
                                                    options={filteredOptions.map(patient => ({ value: patient.vc_reference, label: patient.vc_reference }))}
                                                    value={
                                                        addData.vc_reference
                                                            ? { value: addData.vc_reference, label: addData.vc_reference }
                                                            : null
                                                    }
                                                    onInputChange={(inputValue) => {
                                                        const filtered = allvisit
                                                            .filter(patient => patient.vc_reference.toLowerCase().includes(inputValue.toLowerCase()))
                                                            .slice(0, 5);
                                                        setFilteredOptions(filtered);
                                                    }}
                                                    onChange={handlevisitChange}
                                                    className="form-control"
                                                    name="vc_reference"
                                                    isSearchable

                                                />

                                                {/* <Select
                                                    options={filteredOptions.map(patient => ({ value: patient.vc_reference, label: patient.vc_reference }))}
                                                    onInputChange={(inputValue) => {

                                                        const filtered = allvisit
                                                            .filter(patient => patient.vc_reference.toLowerCase().includes(inputValue.toLowerCase()))
                                                            .slice(0, 5);
                                                        setFilteredOptions(filtered);
                                                    }}
                                                    onChange={handlevisitChange}
                                                    className="form-control"
                                                    name="vc_reference"
                                                    isSearchable
                                                /> */}
                                            </div>
                                        </Col>

                                    </Row>
                                    <Row>
                                        <Col md={3}>
                                            <div className="mb-3">
                                                <Label htmlFor="formrow-country-Input">Date</Label>
                                                <Input
                                                    type="date"
                                                    value={addData.date}
                                                    className="form-control"
                                                    name="date"
                                                    onChange={e => onValueChange(e)}
                                                />
                                            </div>
                                        </Col>
                                        <Col md={3}>
                                            <div className="mb-3">
                                                <Label htmlFor="formrow-country-Input">Patient <span style={{ color: "red", fontWeight: "bolder" }}>*</span></Label>
                                                <select
                                                    name="patient_name"
                                                    className="form-control"
                                                    onChange={e => onValueChange(e)}
                                                >
                                                    <option defaultValue>{addData.patient_name}</option>
                                                    {alluserlist.users.map((user, index) => (
                                                        <option key={index} value={user.firstname}>
                                                            {user.firstname + user.lastname}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </Col>
                                        <Col md={3}>
                                            <div className="mb-3">
                                                <Label htmlFor="formrow-country-Input">
                                                    Practice Name<span style={{ color: "red", fontWeight: "bolder" }}>*</span>
                                                </Label>
                                                <Input
                                                    type="text"
                                                    className="form-control"
                                                    name="practisc_name"
                                                    value={addData.practisc_name}
                                                    placeholder="Practice name"
                                                    onChange={e => onValueChange(e)}
                                                />
                                            </div>
                                        </Col>
                                        <Input
                                            type="text"
                                            className="form-control"
                                            name="patient_id"
                                            hidden
                                            value={addData.patient_id}
                                            placeholder="Practice name"
                                            onChange={e => onValueChange(e)}
                                        />
                                        <Col md={3} style={{ display: "none" }}>
                                            <div className="mb-3">
                                                <Label htmlFor="formrow-country-Input">
                                                    Est. Delivery Date:
                                                </Label>
                                                <Input
                                                    type="date"
                                                    className="form-control"
                                                    name="delivery_date"
                                                    placeholder="Practice Code"
                                                    onChange={e => onValueChange(e)}
                                                />
                                            </div>
                                        </Col>
                                        <Col md={3}>
                                            <div className="mb-3">
                                                <Label htmlFor="formrow-country-Input">
                                                    Order No :
                                                </Label>
                                                <Input
                                                    type="text"
                                                    className="form-control"
                                                    value={Labordernumberview.order_no}
                                                />
                                            </div>
                                        </Col>
                                        <Input
                                            type="text"
                                            hidden
                                            className="form-control"
                                            value={Labordernumber.order_no}
                                            name="order_no"
                                            onChange={e => onValueChange(e)}
                                        />
                                        <Col md={3}>
                                            <div className="mb-3">
                                                <Label htmlFor="formrow-country-Input">
                                                    Payment Details
                                                </Label>
                                                <select
                                                    name="payment_details"
                                                    className="form-control"
                                                    onChange={e => onValueChange(e)}
                                                >
                                                    <option defaultValue>Select</option>
                                                    <option>Card</option>
                                                    <option>EFT</option>
                                                    <option>Cash</option>
                                                    <option>Other</option>
                                                </select>
                                            </div>
                                        </Col>
                                        <Col md={3}>
                                            <div className="mb-3">
                                                <Label htmlFor="formrow-country-Input">
                                                    Delivery information Ship To
                                                </Label>
                                                <select
                                                    name="delivery_info"
                                                    className="form-control"
                                                    onChange={e => onValueChange(e)}
                                                >
                                                    <option defaultValue>Select</option>
                                                    <option>Client Address</option>
                                                    <option>Client to Collect</option>
                                                </select>
                                            </div>
                                        </Col>
                                        <Col md={3} style={{ display: "none" }}>
                                            <div className="mb-3">
                                                <Label htmlFor="formrow-country-Input">
                                                    Order Type
                                                </Label>
                                                <select
                                                    name="order_type"
                                                    className="form-control"
                                                    onChange={e => onValueChange(e)}
                                                >
                                                    <option defaultValue>Select</option>
                                                    <option>Client Address</option>
                                                    <option>Client to Collect</option>
                                                </select>
                                            </div>
                                        </Col>
                                        <hr
                                            style={{
                                                borderTop: "0.1px solid grey",
                                                margin: "20px 0",
                                            }}
                                        />
                                        <Col md={12}>
                                            <h5 className="font-size-14 mb-3">
                                                Frame(mark in the box)
                                            </h5>
                                            <div style={{ display: "flex", alignItems: "center" }}>
                                                <div
                                                    className="form-check form-radio-danger"
                                                    style={{ marginRight: "10px" }}
                                                >
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        name="frame"
                                                        id="yes"
                                                        value="Lab To Supply"
                                                        // defaultChecked
                                                        checked={addData.frame === "Lab To Supply"}
                                                        onChange={e => onValueChange(e)}
                                                    />
                                                    <label
                                                        className="form-check-label"
                                                        htmlFor="exampleRadios1"
                                                    >
                                                        Yes
                                                    </label>
                                                </div>
                                                <div
                                                    className="form-check form-radio-danger"
                                                    style={{ marginRight: "10px" }}
                                                >
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        name="frame"
                                                        id="no"
                                                        value="Supply/Enclosed"
                                                        checked={addData.frame === "Supply/Enclosed"}
                                                        onChange={e => onValueChange(e)}
                                                    />
                                                    <label
                                                        className="form-check-label"
                                                        htmlFor="exampleRadios2"
                                                    >
                                                        No
                                                    </label>
                                                </div>
                                            </div>
                                        </Col>
                                        <hr
                                            style={{
                                                borderTop: "0.1px solid grey",
                                                margin: "20px 0",
                                            }}
                                        />
                                        <Row>
                                            <Col md={12}>
                                                <Row>
                                                    <Col md={4}>
                                                        {isLabToSupply && (
                                                            <>
                                                                <Row>
                                                                    <Col md={6}>
                                                                        <div className="mb-3">
                                                                            <Label htmlFor="formrow-framecolor-Input">
                                                                                Frame Color :
                                                                            </Label>
                                                                            <Input
                                                                                type="text"
                                                                                className="form-control"
                                                                                name="frame_color"
                                                                                value={addData.frame_color}
                                                                                onChange={e => onValueChange(e)}
                                                                            />
                                                                        </div>
                                                                    </Col>
                                                                    <Col md={6}>
                                                                        <div className="mb-3">
                                                                            <Label htmlFor="formrow-size-Input">
                                                                                Size :
                                                                            </Label>
                                                                            <Input
                                                                                type="text"
                                                                                className="form-control"
                                                                                name="frame_size"
                                                                                value={addData.frame_size}
                                                                                onChange={e => onValueChange(e)}
                                                                            />
                                                                        </div>
                                                                    </Col>
                                                                    <Col md={12}>
                                                                        <h5 className="font-size-14 mb-3">Material</h5>
                                                                        <div
                                                                            style={{
                                                                                display: "flex",
                                                                                alignItems: "center",
                                                                            }}
                                                                        >
                                                                            <div
                                                                                className="form-check form-radio-danger"
                                                                                style={{ marginRight: "10px" }}
                                                                            >
                                                                                <input
                                                                                    className="form-check-input"
                                                                                    type="radio"
                                                                                    name="frame_material"
                                                                                    id="material_acetate"
                                                                                    value="Acetate"
                                                                                    checked={
                                                                                        addData.frame_material === "Acetate"
                                                                                    }
                                                                                    onChange={e => onValueChange(e)}
                                                                                />
                                                                                <label
                                                                                    className="form-check-label"
                                                                                    htmlFor="exampleRadios1"
                                                                                >
                                                                                    Acetate
                                                                                </label>
                                                                            </div>
                                                                            <div
                                                                                className="form-check form-radio-danger"
                                                                                style={{ marginRight: "10px" }}
                                                                            >
                                                                                <input
                                                                                    className="form-check-input"
                                                                                    type="radio"
                                                                                    name="frame_material"
                                                                                    id="material_titanium"
                                                                                    value="Titanium"
                                                                                    checked={
                                                                                        addData.frame_material === "Titanium"
                                                                                    }
                                                                                    onChange={e => onValueChange(e)}
                                                                                />
                                                                                <label
                                                                                    className="form-check-label"
                                                                                    htmlFor="exampleRadios2"
                                                                                >
                                                                                    Titanium
                                                                                </label>
                                                                            </div>
                                                                            <div
                                                                                className="form-check form-radio-danger"
                                                                                style={{ marginRight: "10px" }}
                                                                            >
                                                                                <input
                                                                                    className="form-check-input"
                                                                                    type="radio"
                                                                                    name="frame_material"
                                                                                    id="material_nylon"
                                                                                    value="Nylon"
                                                                                    checked={
                                                                                        addData.frame_material === "Nylon"
                                                                                    }
                                                                                    onChange={e => onValueChange(e)}
                                                                                />
                                                                                <label
                                                                                    className="form-check-label"
                                                                                    htmlFor="exampleRadios2"
                                                                                >
                                                                                    Nylon
                                                                                </label>
                                                                            </div>
                                                                        </div>
                                                                    </Col>
                                                                    <Col md={12}>
                                                                        <br />
                                                                        <h5 className="font-size-14 mb-3">Type</h5>
                                                                        <div
                                                                            style={{
                                                                                display: "flex",
                                                                                alignItems: "center",
                                                                            }}
                                                                        >
                                                                            <div
                                                                                className="form-check form-radio-danger"
                                                                                style={{ marginRight: "10px" }}
                                                                            >
                                                                                <input
                                                                                    className="form-check-input"
                                                                                    type="radio"
                                                                                    name="frame_type"
                                                                                    id="type_fullrim"
                                                                                    value="Full Rim"
                                                                                    checked={
                                                                                        addData.frame_type === "Full Rim"
                                                                                    }
                                                                                    onChange={e => onValueChange(e)}
                                                                                />

                                                                                <label
                                                                                    className="form-check-label"
                                                                                    htmlFor="exampleRadios1"
                                                                                >
                                                                                    Full Rim
                                                                                </label>
                                                                            </div>
                                                                            <div
                                                                                className="form-check form-radio-danger"
                                                                                style={{ marginRight: "10px" }}
                                                                            >
                                                                                <input
                                                                                    className="form-check-input"
                                                                                    type="radio"
                                                                                    name="frame_type"
                                                                                    id="type_semi_rimless"
                                                                                    value="Semi-rimless"
                                                                                    checked={
                                                                                        addData.frame_type === "Semi-rimless"
                                                                                    }
                                                                                    onChange={e => onValueChange(e)}
                                                                                />
                                                                                <label
                                                                                    className="form-check-label"
                                                                                    htmlFor="exampleRadios2"
                                                                                >
                                                                                    Semi-rimless
                                                                                </label>
                                                                            </div>
                                                                            <div
                                                                                className="form-check form-radio-danger"
                                                                                style={{ marginRight: "10px" }}
                                                                            >
                                                                                <input
                                                                                    className="form-check-input"
                                                                                    type="radio"
                                                                                    name="frame_type"
                                                                                    id="type_nylon"
                                                                                    value="Nylon"
                                                                                    checked={addData.frame_type === "Nylon"}
                                                                                    onChange={e => onValueChange(e)}
                                                                                />
                                                                                <label
                                                                                    className="form-check-label"
                                                                                    htmlFor="exampleRadios2"
                                                                                >
                                                                                    Nylon
                                                                                </label>
                                                                            </div>
                                                                        </div>
                                                                    </Col>

                                                                    <Col md={12}>
                                                                        <h5 className="font-size-14 mb-3">Shape</h5>
                                                                        <div
                                                                            style={{
                                                                                display: "flex",
                                                                                alignItems: "center",
                                                                            }}
                                                                        >
                                                                            <div
                                                                                className="form-check form-radio-danger"
                                                                                style={{ marginRight: "10px" }}
                                                                            >
                                                                                <input
                                                                                    className="form-check-input"
                                                                                    type="radio"
                                                                                    name="frame_shape"
                                                                                    id="shape_rectangle"
                                                                                    value="Rectangle"
                                                                                    checked={
                                                                                        addData.frame_shape === "Rectangle"
                                                                                    }
                                                                                    onChange={e => onValueChange(e)}
                                                                                />
                                                                                <label
                                                                                    className="form-check-label"
                                                                                    htmlFor="exampleRadios1"
                                                                                >
                                                                                    Rectangle
                                                                                </label>
                                                                            </div>
                                                                            <div
                                                                                className="form-check form-radio-danger"
                                                                                style={{ marginRight: "10px" }}
                                                                            >
                                                                                <input
                                                                                    className="form-check-input"
                                                                                    type="radio"
                                                                                    name="frame_shape"
                                                                                    id="shape_cat_eye"
                                                                                    value="cat-eye"
                                                                                    checked={
                                                                                        addData.frame_shape === "cat-eye"
                                                                                    }
                                                                                    onChange={e => onValueChange(e)}
                                                                                />
                                                                                <label
                                                                                    className="form-check-label"
                                                                                    htmlFor="exampleRadios2"
                                                                                >
                                                                                    cat-eye
                                                                                </label>
                                                                            </div>
                                                                            <div
                                                                                className="form-check form-radio-danger"
                                                                                style={{ marginRight: "10px" }}
                                                                            >
                                                                                <input
                                                                                    className="form-check-input"
                                                                                    type="radio"
                                                                                    name="frame_shape"
                                                                                    id="no"
                                                                                    value="Round"
                                                                                    checked={addData.frame_shape === "Round"}
                                                                                    onChange={e => onValueChange(e)}
                                                                                />
                                                                                <label
                                                                                    className="form-check-label"
                                                                                    htmlFor="exampleRadios2"
                                                                                >
                                                                                    Round
                                                                                </label>
                                                                            </div>
                                                                            <div
                                                                                className="form-check form-radio-danger"
                                                                                style={{ marginRight: "10px" }}
                                                                            >
                                                                                <input
                                                                                    className="form-check-input"
                                                                                    type="radio"
                                                                                    name="frame_shape"
                                                                                    id="no"
                                                                                    value="Oval"
                                                                                    checked={addData.frame_shape === "Oval"}
                                                                                    onChange={e => onValueChange(e)}
                                                                                />
                                                                                <label
                                                                                    className="form-check-label"
                                                                                    htmlFor="exampleRadios2"
                                                                                >
                                                                                    Oval
                                                                                </label>
                                                                            </div>
                                                                        </div>
                                                                    </Col>
                                                                    <Col md={12}>
                                                                        <div className="mb-3">
                                                                            <Label htmlFor="formrow-framecolor-Input">
                                                                                Frame Brand :
                                                                            </Label>
                                                                            <Input
                                                                                type="text"
                                                                                className="form-control"
                                                                                name="frame_brand"
                                                                                onChange={e => onValueChange(e)}
                                                                            />
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                                <hr
                                                                    style={{
                                                                        borderTop: "0.1px solid grey",
                                                                        margin: "20px 0",
                                                                    }}
                                                                />
                                                            </>
                                                        )}
                                                        <h5 className="text-danger">Lens Details</h5>
                                                        <hr
                                                            style={{
                                                                borderTop: "0.1px solid grey",
                                                                margin: "20px 0",
                                                            }}
                                                        />
                                                        <Row>
                                                            <Col md={7}>
                                                                <h5 className="font-size-14 mb-3">Material</h5>
                                                                <div
                                                                    style={{
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                    }}
                                                                >
                                                                    <div
                                                                        className="form-check form-radio-danger"
                                                                        style={{ marginRight: "10px" }}
                                                                    >
                                                                        <input
                                                                            className="form-check-input"
                                                                            type="radio"
                                                                            name="lens_material"
                                                                            id="no"
                                                                            value="CR-39(Plastic)"
                                                                            checked={
                                                                                addData.lens_material ===
                                                                                "CR-39(Plastic)"
                                                                            }
                                                                            onChange={e => onValueChange(e)}
                                                                        />
                                                                        <label
                                                                            className="form-check-label"
                                                                            htmlFor="exampleRadios2"
                                                                        >
                                                                            CR-39(Plastic)
                                                                        </label>
                                                                    </div>
                                                                    <div
                                                                        className="form-check form-radio-danger"
                                                                        style={{ marginRight: "10px" }}
                                                                    >
                                                                        <input
                                                                            className="form-check-input"
                                                                            type="radio"
                                                                            name="lens_material"
                                                                            id="no"
                                                                            value="Glass"
                                                                            checked={
                                                                                addData.lens_material === "Glass"
                                                                            }
                                                                            onChange={e => onValueChange(e)}
                                                                        />
                                                                        <label
                                                                            className="form-check-label"
                                                                            htmlFor="exampleRadios2"
                                                                        >
                                                                            Glass
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            </Col>

                                                            <Col md={6}>
                                                                <div className="mb-3">
                                                                    <Label htmlFor="formrow-country-Input"></Label>
                                                                    <select
                                                                        name="lens_vision"
                                                                        className="form-control"
                                                                        onChange={(e) => {
                                                                            handleVisionChange(e);
                                                                            onValueChange(e);
                                                                        }}
                                                                    >
                                                                        <option defaultValue>Select vision</option>
                                                                        {vision.users.map((user, index) => (
                                                                            <option key={index} value={user._id}>
                                                                                {user.vision}
                                                                            </option>
                                                                        ))}
                                                                    </select>
                                                                </div>
                                                            </Col>
                                                            <Col md={6}>
                                                                <div className="mb-3">
                                                                    <Label htmlFor="formrow-country-Input"></Label>
                                                                    <select
                                                                        name="lens_subvision"
                                                                        className="form-control"
                                                                        onChange={e => onValueChange(e)}
                                                                    >
                                                                        <option defaultValue>Select vision type</option>
                                                                        {filteredOptionsvisionType.map((user, index) => (
                                                                            <option key={index} value={user._id}>
                                                                                {user.vision_type}
                                                                            </option>
                                                                        ))}
                                                                    </select>
                                                                </div>
                                                            </Col>
                                                            <Col md={6}>
                                                                {/* <h5 className="font-size-14 mb-3">Tint [Uncoated Lenses]</h5> */}

                                                                <div
                                                                    style={{
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                    }}
                                                                >
                                                                    <div
                                                                        className="form-check form-radio-danger"
                                                                        style={{ marginRight: "10px" }}
                                                                    >
                                                                        <input
                                                                            className="form-check-input"
                                                                            type="radio"
                                                                            name="lens_type"
                                                                            id="no"
                                                                            value="Uncoated"
                                                                            checked={addData.lens_type === "Uncoated"}
                                                                            onChange={e => onValueChange(e)}
                                                                        />
                                                                        <label
                                                                            className="form-check-label"
                                                                            htmlFor="exampleRadios2"
                                                                        >
                                                                            Uncoated
                                                                        </label>
                                                                    </div>
                                                                    <div
                                                                        className="form-check form-radio-danger"
                                                                        style={{ marginRight: "10px" }}
                                                                    >
                                                                        <input
                                                                            className="form-check-input"
                                                                            type="radio"
                                                                            name="lens_type"
                                                                            id="no"
                                                                            value="Hard"
                                                                            checked={addData.lens_type === "Hard"}
                                                                            onChange={e => onValueChange(e)}
                                                                        />
                                                                        <label
                                                                            className="form-check-label"
                                                                            htmlFor="exampleRadios2"
                                                                        >
                                                                            Hard
                                                                        </label>
                                                                    </div>
                                                                    <br />
                                                                    <div
                                                                        className="form-check form-radio-danger"
                                                                        style={{ marginRight: "10px" }}
                                                                    >
                                                                        <input
                                                                            className="form-check-input"
                                                                            type="radio"
                                                                            name="lens_type"
                                                                            id="no"
                                                                            value="HMC"
                                                                            checked={addData.lens_type === "HMC"}
                                                                            onChange={e => onValueChange(e)}
                                                                        />
                                                                        <label
                                                                            className="form-check-label"
                                                                            htmlFor="exampleRadios2"
                                                                        >
                                                                            HMC
                                                                        </label>
                                                                    </div>
                                                                    <div
                                                                        className="form-check form-radio-danger"
                                                                        style={{ marginRight: "10px" }}
                                                                    >
                                                                        <input
                                                                            className="form-check-input"
                                                                            type="radio"
                                                                            name="lens_type"
                                                                            id="no"
                                                                            value="ARC"
                                                                            checked={addData.lens_type === "ARC"}
                                                                            onChange={e => onValueChange(e)}
                                                                        />
                                                                        <label
                                                                            className="form-check-label"
                                                                            htmlFor="exampleRadios2"
                                                                        >
                                                                            ARC
                                                                        </label>
                                                                    </div>
                                                                    <div
                                                                        className="form-check form-radio-danger"
                                                                        style={{ marginRight: "10px" }}
                                                                    >
                                                                        <input
                                                                            className="form-check-input"
                                                                            type="radio"
                                                                            name="lens_type"
                                                                            id="no"
                                                                            value="Blue"
                                                                            checked={addData.lens_type === "Blue"}
                                                                            onChange={e => onValueChange(e)}
                                                                        />
                                                                        <label
                                                                            className="form-check-label"
                                                                            htmlFor="exampleRadios2"
                                                                        >
                                                                            Blue
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                                <br />
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                    <Col md={8}>
                                                        <Row>
                                                            <Col lg={12}>
                                                                <Card>
                                                                    <CardBody>
                                                                        {/* <CardTitle className="h4">Table head</CardTitle> */}
                                                                        <div className="table-responsive">
                                                                            <Table className="table mb-0">
                                                                                <thead className="table-light">
                                                                                    <tr>
                                                                                        <th></th>
                                                                                        <th>Spere</th>
                                                                                        <th>Cyl</th>
                                                                                        <th>Axis</th>
                                                                                        <th>Add</th>
                                                                                        <th>Seg Height</th>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    <tr>
                                                                                        <th scope="row">OD[Right]</th>
                                                                                        <td>
                                                                                            <Input
                                                                                                type="text"
                                                                                                className="form-control"
                                                                                                name="od_spere"
                                                                                                value={addData.od_spere}
                                                                                                onClick={() => handleInputClick("od_spere")}
                                                                                                onChange={onValueChange}
                                                                                            />
                                                                                            {/* <Input
                                                type="text"
                                                className="form-control"
                                                name="os_spere"
                                                value={addData.od_spere}
                                                onClick={() =>
                                                  handleInputClick("os_spere")
                                                }
                                                onChange={e => onValueChange(e)}
                                              /> */}
                                                                                        </td>
                                                                                        <td>
                                                                                            <Input
                                                                                                type="text"
                                                                                                className="form-control"
                                                                                                name="od_cyl"
                                                                                                value={addData.od_cyl}
                                                                                                onClick={() => handleInputClick1("od_cyl")}
                                                                                                onChange={onValueChange}
                                                                                            />
                                                                                        </td>
                                                                                        <td>
                                                                                            <select
                                                                                                name="od_axis"
                                                                                                className="form-control"
                                                                                                onChange={e => onValueChange(e)}
                                                                                            >
                                                                                                <option defaultValue>
                                                                                                    Select
                                                                                                </option>
                                                                                                {renderDropdownOptions()}
                                                                                            </select>
                                                                                        </td>
                                                                                        <td>
                                                                                            <select
                                                                                                name="od_add"
                                                                                                className="form-control"
                                                                                                onChange={e => onValueChange(e)}
                                                                                            >
                                                                                                <option defaultValue>
                                                                                                    Select
                                                                                                </option>
                                                                                                <option>+0.75</option>
                                                                                                <option>+1.00</option>
                                                                                                <option>+1.25</option>
                                                                                                <option>+1.50</option>
                                                                                                <option>+1.75</option>
                                                                                                <option>+2.00</option>
                                                                                                <option>+2.25</option>
                                                                                                <option>+2.50</option>
                                                                                                <option>+2.75</option>
                                                                                                <option>+3.00</option>
                                                                                                <option>+3.25</option>
                                                                                                <option>+3.50</option>
                                                                                            </select>
                                                                                        </td>
                                                                                        <td>
                                                                                            <select
                                                                                                name="od_seg_height"
                                                                                                className="form-control"
                                                                                                onChange={e => onValueChange(e)}
                                                                                            >
                                                                                                <option defaultValue>
                                                                                                    Select
                                                                                                </option>
                                                                                                {renderDropdownOptions1()}
                                                                                            </select>
                                                                                        </td>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <th scope="row">OS[Left]</th>
                                                                                        <td>
                                                                                            <Input
                                                                                                type="text"
                                                                                                className="form-control"
                                                                                                name="os_spere"
                                                                                                value={addData.os_spere}
                                                                                                onClick={() => handleInputClick("os_spere")}
                                                                                                onChange={onValueChange}
                                                                                            />
                                                                                        </td>
                                                                                        <td>
                                                                                            <Input
                                                                                                type="text"
                                                                                                className="form-control"
                                                                                                name="os_cyl"
                                                                                                value={addData.os_cyl}
                                                                                                onClick={() => handleInputClick1("os_cyl")}
                                                                                                onChange={onValueChange}
                                                                                            />
                                                                                        </td>
                                                                                        <td>
                                                                                            <select
                                                                                                name="os_axis"
                                                                                                className="form-control"
                                                                                                onChange={e => onValueChange(e)}
                                                                                            >
                                                                                                <option defaultValue>
                                                                                                    Select
                                                                                                </option>
                                                                                                {renderDropdownOptions()}
                                                                                            </select>
                                                                                        </td>
                                                                                        <td>
                                                                                            <select
                                                                                                name="os_add"
                                                                                                className="form-control"
                                                                                                onChange={e => onValueChange(e)}
                                                                                            >
                                                                                                <option defaultValue>
                                                                                                    Select
                                                                                                </option>
                                                                                                <option>+0.75</option>
                                                                                                <option>+1.00</option>
                                                                                                <option>+1.25</option>
                                                                                                <option>+1.50</option>
                                                                                                <option>+1.75</option>
                                                                                                <option>+2.00</option>
                                                                                                <option>+2.25</option>
                                                                                                <option>+2.50</option>
                                                                                                <option>+2.75</option>
                                                                                                <option>+3.00</option>
                                                                                                <option>+3.25</option>
                                                                                                <option>+3.50</option>
                                                                                            </select>
                                                                                        </td>
                                                                                        <td>
                                                                                            <select
                                                                                                name="os_seg_height"
                                                                                                className="form-control"
                                                                                                onChange={e => onValueChange(e)}
                                                                                            >
                                                                                                <option defaultValue>
                                                                                                    Select
                                                                                                </option>
                                                                                                {renderDropdownOptions1()}
                                                                                            </select>
                                                                                        </td>
                                                                                    </tr>
                                                                                </tbody>
                                                                            </Table>
                                                                            <div>
                                                                                <p>
                                                                                    Or you can{" "}
                                                                                    <span
                                                                                        style={{
                                                                                            color: "red",
                                                                                            textDecoration: "underline",
                                                                                            cursor: "pointer",
                                                                                        }}
                                                                                        onClick={handleClicks}
                                                                                    >
                                                                                        upload prescription paper here
                                                                                    </span>.
                                                                                </p>

                                                                                <input
                                                                                    type="file"
                                                                                    ref={fileInputRef}
                                                                                    onChange={handleFileChange}
                                                                                    style={{ display: "none" }}
                                                                                />

                                                                                {/* Display file info if selected */}
                                                                                {selectedFile && (
                                                                                    <div style={{ display: "flex", alignItems: "center", marginTop: "8px" }}>
                                                                                        <span role="img" aria-label="file" style={{ marginRight: "8px" }}>
                                                                                            📄
                                                                                        </span>
                                                                                        <span>{selectedFile.name}</span>
                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                            <Row>
                                                                                {!isTwoPD && (
                                                                                    <Col md={6}>
                                                                                        <div className="mb-3">
                                                                                            <Label htmlFor="formrow-framecolor-Input">
                                                                                                PD :
                                                                                            </Label>
                                                                                            <Input
                                                                                                type="text"
                                                                                                className="form-control"
                                                                                                name="pd"
                                                                                                placeholder="PD"
                                                                                                value={addData.pd}
                                                                                                onClick={() =>
                                                                                                    handleInputClick2(
                                                                                                        "pd"
                                                                                                    )
                                                                                                }
                                                                                                onChange={e => onValueChange(e)}
                                                                                            />
                                                                                        </div>
                                                                                    </Col>
                                                                                )}
                                                                                {isTwoPD && (
                                                                                    <>
                                                                                        <Col md={4}>
                                                                                            <div className="mb-3">
                                                                                                <Label htmlFor="formrow-framecolor-Input">
                                                                                                    PD Left :
                                                                                                </Label>
                                                                                                <Input
                                                                                                    type="text"
                                                                                                    className="form-control"
                                                                                                    name="pd_left"
                                                                                                    placeholder="PD Left"
                                                                                                    value={addData.pd_left}
                                                                                                    onClick={() =>
                                                                                                        handleInputClick3(
                                                                                                            "pd_left"
                                                                                                        )
                                                                                                    }
                                                                                                    onChange={e =>
                                                                                                        onValueChange(e)
                                                                                                    }
                                                                                                />
                                                                                            </div>
                                                                                        </Col>
                                                                                        <Col md={4}>
                                                                                            <div className="mb-3">
                                                                                                <Label htmlFor="formrow-framecolor-Input" >
                                                                                                    PD Right :
                                                                                                </Label>
                                                                                                <Input
                                                                                                    type="text"
                                                                                                    className="form-control"
                                                                                                    name="pd_right"
                                                                                                    placeholder="PD Right"
                                                                                                    value={addData.pd_right}
                                                                                                    onClick={() =>
                                                                                                        handleInputClick3(
                                                                                                            "pd_right"
                                                                                                        )
                                                                                                    }
                                                                                                    onChange={e =>
                                                                                                        onValueChange(e)
                                                                                                    }
                                                                                                />
                                                                                            </div>
                                                                                        </Col>
                                                                                    </>
                                                                                )}
                                                                                <Col md={4}>
                                                                                    <br />
                                                                                    <div
                                                                                        className="form-check form-radio-danger"
                                                                                        style={{ marginTop: "20px" }}
                                                                                    >
                                                                                        <input
                                                                                            className="form-check-input"
                                                                                            type="checkbox"
                                                                                            id="two_pd_number"
                                                                                            checked={isTwoPD}
                                                                                            onChange={onCheckboxChange}
                                                                                        />
                                                                                        <label
                                                                                            className="form-check-label"
                                                                                            htmlFor="twoPdCheckbox"
                                                                                        >
                                                                                            Two PD Number
                                                                                        </label>
                                                                                    </div>
                                                                                </Col>
                                                                                <hr
                                                                                    style={{
                                                                                        borderTop: "0.1px solid grey",
                                                                                        margin: "10px 0",
                                                                                    }}
                                                                                />
                                                                                <Col md={4}>
                                                                                    <div
                                                                                        className="form-check form-radio-danger"
                                                                                        style={{ marginTop: "9px" }}
                                                                                    >
                                                                                        <input
                                                                                            className="form-check-input"
                                                                                            type="checkbox"
                                                                                            id="addprism"
                                                                                            name="add_prism"
                                                                                            //   checked={}
                                                                                            onChange={e => onValueChange(e)}
                                                                                        />
                                                                                        <label
                                                                                            className="form-check-label"
                                                                                            htmlFor="addprism"

                                                                                        >
                                                                                            Add Prism
                                                                                        </label>
                                                                                    </div>
                                                                                </Col>
                                                                                <Table className="table mb-0">
                                                                                    <thead className="table-light">
                                                                                        <tr>
                                                                                            <th></th>
                                                                                            <th>Vertical (A)</th>
                                                                                            <th>Base Direction</th>
                                                                                            <th>Horizontal (A)</th>
                                                                                            <th>Base Direction</th>
                                                                                        </tr>
                                                                                    </thead>
                                                                                    <tbody>
                                                                                        <tr>
                                                                                            <th scope="row">OD[Right]</th>
                                                                                            <td>
                                                                                                <select
                                                                                                    name="od_vertical"
                                                                                                    className="form-control"
                                                                                                    onChange={e =>
                                                                                                        onValueChange(e)
                                                                                                    }
                                                                                                >
                                                                                                    <option defaultValue>
                                                                                                        Select vertical OD
                                                                                                    </option>
                                                                                                    <option>0.50</option>
                                                                                                    <option>1.50</option>
                                                                                                    <option>2.00</option>
                                                                                                    <option>2.50</option>
                                                                                                    <option>3.00</option>
                                                                                                    <option>3.50</option>
                                                                                                    <option>4.00</option>
                                                                                                    <option>4.50</option>
                                                                                                    <option>5.00</option>
                                                                                                    <option>5.50</option>
                                                                                                    <option>6.00</option>
                                                                                                </select>
                                                                                            </td>
                                                                                            <td>
                                                                                                <select
                                                                                                    name="od_vb_direction"
                                                                                                    className="form-control"
                                                                                                    onChange={e =>
                                                                                                        onValueChange(e)
                                                                                                    }
                                                                                                >
                                                                                                    <option defaultValue>
                                                                                                        Base direction
                                                                                                    </option>
                                                                                                    <option>Up</option>
                                                                                                    <option>Down</option>
                                                                                                </select>
                                                                                            </td>
                                                                                            <td>
                                                                                                <select
                                                                                                    name="od_hb_direction"
                                                                                                    className="form-control"
                                                                                                    onChange={e =>
                                                                                                        onValueChange(e)
                                                                                                    }
                                                                                                >
                                                                                                    <option defaultValue>
                                                                                                        Select vertical OD
                                                                                                    </option>
                                                                                                    <option>0.50</option>
                                                                                                    <option>1.50</option>
                                                                                                    <option>2.00</option>
                                                                                                    <option>2.50</option>
                                                                                                    <option>3.00</option>
                                                                                                    <option>3.50</option>
                                                                                                    <option>4.00</option>
                                                                                                    <option>4.50</option>
                                                                                                    <option>5.00</option>
                                                                                                    <option>5.50</option>
                                                                                                    <option>6.00</option>
                                                                                                </select>
                                                                                            </td>
                                                                                            <td>
                                                                                                <select
                                                                                                    name="od_horizontal"
                                                                                                    className="form-control"
                                                                                                    onChange={e =>
                                                                                                        onValueChange(e)
                                                                                                    }
                                                                                                >
                                                                                                    <option defaultValue>
                                                                                                        Base Direction
                                                                                                    </option>
                                                                                                    <option>IN</option>
                                                                                                    <option>OUT</option>
                                                                                                </select>
                                                                                            </td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <th scope="row">OS[Left]</th>
                                                                                            <td>
                                                                                                <select
                                                                                                    name="os_vertical"
                                                                                                    className="form-control"
                                                                                                    onChange={e =>
                                                                                                        onValueChange(e)
                                                                                                    }
                                                                                                >
                                                                                                    <option defaultValue>
                                                                                                        Select
                                                                                                    </option>
                                                                                                    <option>0.50</option>
                                                                                                    <option>1.50</option>
                                                                                                    <option>2.00</option>
                                                                                                    <option>2.50</option>
                                                                                                    <option>3.00</option>
                                                                                                    <option>3.50</option>
                                                                                                    <option>4.00</option>
                                                                                                    <option>4.50</option>
                                                                                                    <option>5.00</option>
                                                                                                    <option>5.50</option>
                                                                                                    <option>6.00</option>
                                                                                                </select>
                                                                                            </td>
                                                                                            <td>
                                                                                                <select
                                                                                                    name="os_vb_direction"
                                                                                                    className="form-control"
                                                                                                    onChange={e =>
                                                                                                        onValueChange(e)
                                                                                                    }
                                                                                                >
                                                                                                    <option defaultValue>
                                                                                                        Base Direction
                                                                                                    </option>
                                                                                                    <option>Up</option>
                                                                                                    <option>Down</option>
                                                                                                </select>
                                                                                            </td>
                                                                                            <td>
                                                                                                <select
                                                                                                    name="os_horizontal"
                                                                                                    className="form-control"
                                                                                                    onChange={e =>
                                                                                                        onValueChange(e)
                                                                                                    }
                                                                                                >
                                                                                                    <option defaultValue>
                                                                                                        Select
                                                                                                    </option>
                                                                                                    <option>0.50</option>
                                                                                                    <option>1.50</option>
                                                                                                    <option>2.00</option>
                                                                                                    <option>2.50</option>
                                                                                                    <option>3.00</option>
                                                                                                    <option>3.50</option>
                                                                                                    <option>4.00</option>
                                                                                                    <option>4.50</option>
                                                                                                    <option>5.00</option>
                                                                                                    <option>5.50</option>
                                                                                                    <option>6.00</option>
                                                                                                </select>
                                                                                            </td>
                                                                                            <td>
                                                                                                <select
                                                                                                    name="os_hb_direction"
                                                                                                    className="form-control"
                                                                                                    onChange={e =>
                                                                                                        onValueChange(e)
                                                                                                    }
                                                                                                >
                                                                                                    <option defaultValue>
                                                                                                        Base Direction
                                                                                                    </option>
                                                                                                    <option>IN</option>
                                                                                                    <option>OUT</option>
                                                                                                    {renderDropdownOptions1()}
                                                                                                </select>
                                                                                            </td>
                                                                                        </tr>
                                                                                    </tbody>
                                                                                </Table>
                                                                            </Row>
                                                                            <hr
                                                                                style={{
                                                                                    borderTop: "0.1px solid grey",
                                                                                    margin: "20px 0",
                                                                                }}
                                                                            />
                                                                            <Modal
                                                                                isOpen={modalOpen}
                                                                                toggle={() => setModalOpen(!modalOpen)}
                                                                            >
                                                                                <ModalHeader
                                                                                    toggle={() =>
                                                                                        setModalOpen(!modalOpen)
                                                                                    }
                                                                                >
                                                                                    SPH(Right)
                                                                                </ModalHeader>
                                                                                <ModalBody>
                                                                                    <Row>
                                                                                        <Col md={12}>
                                                                                            <Row>
                                                                                                <Col md={6}>
                                                                                                    <h5>(-) Minus values</h5>
                                                                                                    {[
                                                                                                        "-0.25",
                                                                                                        "-0.50",
                                                                                                        "-0.75",
                                                                                                        "-1.00",
                                                                                                        "-1.50",
                                                                                                        "-1.75",
                                                                                                        "-2.00",
                                                                                                        "-2.00",
                                                                                                        "-2.25",
                                                                                                        "-2.50",
                                                                                                        "-2.75",
                                                                                                        "-3.00",
                                                                                                        "-3.25",
                                                                                                        "-3.50",
                                                                                                        "-3.75",
                                                                                                        "-4.00",
                                                                                                        "-4.25",
                                                                                                        "-4.50",
                                                                                                        "-4.75",
                                                                                                        "-5.00",
                                                                                                        "-5.25",
                                                                                                    ].map((value, index) => (
                                                                                                        <Button
                                                                                                            key={index}
                                                                                                            outline="secondary"
                                                                                                            style={{
                                                                                                                margin: "5px",
                                                                                                                width:
                                                                                                                    "calc(30% - 10px)",
                                                                                                            }}
                                                                                                            onClick={() =>
                                                                                                                handleSelectValue(value)
                                                                                                            }
                                                                                                        >
                                                                                                            {value}
                                                                                                        </Button>
                                                                                                    ))}
                                                                                                </Col>
                                                                                                <Col md={6}>
                                                                                                    <h5>(+) Plus values</h5>
                                                                                                    {[
                                                                                                        "+0.25",
                                                                                                        "+0.50",
                                                                                                        "+0.75",
                                                                                                        "+1.00",
                                                                                                        "+1.50",
                                                                                                        "+1.75",
                                                                                                        "+2.00",
                                                                                                        "+2.00",
                                                                                                        "+2.25",
                                                                                                        "+2.50",
                                                                                                        "+2.75",
                                                                                                        "+3.00",
                                                                                                        "+3.25",
                                                                                                        "+3.50",
                                                                                                        "+3.75",
                                                                                                        "+4.00",
                                                                                                        "+4.25",
                                                                                                        "+4.50",
                                                                                                        "+4.75",
                                                                                                        "+5.00",
                                                                                                        "+5.25",
                                                                                                    ].map((value, index) => (
                                                                                                        <Button
                                                                                                            key={index}
                                                                                                            outline="secondary"
                                                                                                            style={{
                                                                                                                margin: "5px",
                                                                                                                width:
                                                                                                                    "calc(30% - 10px)",
                                                                                                            }}
                                                                                                            onClick={() =>
                                                                                                                handleSelectValue(value)
                                                                                                            }
                                                                                                        >
                                                                                                            {value}
                                                                                                        </Button>
                                                                                                    ))}
                                                                                                </Col>
                                                                                            </Row>
                                                                                        </Col>
                                                                                    </Row>
                                                                                </ModalBody>
                                                                                <ModalFooter>
                                                                                    {/* <Button color="light" onClick={() => setModalOpen(false)}>Cancel</Button> */}
                                                                                </ModalFooter>
                                                                            </Modal>
                                                                            <Modal
                                                                                isOpen={modalOpen1}
                                                                                toggle={() =>
                                                                                    setModalOpen1(!modalOpen1)
                                                                                }
                                                                            >
                                                                                <ModalHeader
                                                                                    toggle={() =>
                                                                                        setModalOpen1(!modalOpen1)
                                                                                    }
                                                                                >
                                                                                    CYL(Right)
                                                                                </ModalHeader>
                                                                                <ModalBody>
                                                                                    <h5>(-) Minus values</h5>
                                                                                    {[
                                                                                        "-0.25",
                                                                                        "-0.50",
                                                                                        "-0.75",
                                                                                        "-1.00",
                                                                                        "-1.50",
                                                                                        "-1.75",
                                                                                        "-2.00",
                                                                                        "-2.00",
                                                                                        "-2.25",
                                                                                        "-2.50",
                                                                                        "-2.75",
                                                                                        "-3.00",
                                                                                        "-3.25",
                                                                                        "-3.50",
                                                                                        "-3.75",
                                                                                        "-4.00",
                                                                                        "-4.25",
                                                                                        "-4.50",
                                                                                        "-4.75",
                                                                                        "-5.00",
                                                                                        "-5.25",
                                                                                        "-6.00",
                                                                                        "-6.25",
                                                                                        "-6.50",
                                                                                    ].map((value, index) => (
                                                                                        <Button
                                                                                            key={index}
                                                                                            outline="secondary"
                                                                                            style={{
                                                                                                margin: "5px",
                                                                                                width: "calc(15% - 10px)",
                                                                                            }}
                                                                                            onClick={() =>
                                                                                                handleSelectValue1(value)
                                                                                            }
                                                                                        >
                                                                                            {value}
                                                                                        </Button>
                                                                                    ))}
                                                                                </ModalBody>
                                                                                <ModalFooter>
                                                                                    {/* <Button color="light" onClick={() => setModalOpen(false)}>Cancel</Button> */}
                                                                                </ModalFooter>
                                                                            </Modal>
                                                                            <Modal
                                                                                isOpen={modalOpen2}
                                                                                toggle={() =>
                                                                                    setModalOpen2(!modalOpen2)
                                                                                }
                                                                            >
                                                                                <ModalHeader
                                                                                    toggle={() =>
                                                                                        setModalOpen2(!modalOpen2)
                                                                                    }
                                                                                >
                                                                                    PD(Pupillary Distance)
                                                                                </ModalHeader>
                                                                                <ModalBody>
                                                                                    {/* <h5>(-) Minus values</h5> */}
                                                                                    {[
                                                                                        "54.00",
                                                                                        "54.50",
                                                                                        "55.00",
                                                                                        "55.50",
                                                                                        "56.00",
                                                                                        "56.50",
                                                                                        "57.00",
                                                                                        "57.50",
                                                                                        "58.00",
                                                                                        "58.50",
                                                                                        "59.00",
                                                                                        "59.50",
                                                                                        "60.00",
                                                                                        "60.50",
                                                                                        "61.00",
                                                                                        "61.50",
                                                                                        "62.00",
                                                                                        "62.50",
                                                                                        "63.00",
                                                                                        "63.50",
                                                                                        "64.00",
                                                                                        "64.50",
                                                                                        "65.00",
                                                                                        "65.50",
                                                                                        "66.00",
                                                                                        "66.50",
                                                                                        "67.00",
                                                                                        "67.50",
                                                                                        "68.00",
                                                                                        "68.50",
                                                                                        "69.00",
                                                                                        "69.50",
                                                                                        "70.00",
                                                                                        "70.50",
                                                                                        "71.00",
                                                                                        "71.50",
                                                                                        "72.00",
                                                                                        "72.50",
                                                                                        "73.00",
                                                                                        "73.50",
                                                                                        "74.00",
                                                                                        "74.50",
                                                                                        "75.00",
                                                                                        "75.50",
                                                                                        "76.00",
                                                                                        "76.50",
                                                                                        "77.00",
                                                                                        "77.50",
                                                                                        "78.00",
                                                                                        "78.50",
                                                                                    ].map((value, index) => (
                                                                                        <Button
                                                                                            key={index}
                                                                                            outline="secondary"
                                                                                            style={{
                                                                                                margin: "5px",
                                                                                                width: "calc(15% - 10px)",
                                                                                            }}
                                                                                            onClick={() =>
                                                                                                handleSelectValue2(value)
                                                                                            }
                                                                                        >
                                                                                            {value}
                                                                                        </Button>
                                                                                    ))}
                                                                                </ModalBody>
                                                                                <ModalFooter>
                                                                                    {/* <Button color="light" onClick={() => setModalOpen(false)}>Cancel</Button> */}
                                                                                </ModalFooter>
                                                                            </Modal>
                                                                            <Modal
                                                                                isOpen={modalOpen3}
                                                                                toggle={() =>
                                                                                    setModalOpen3(!modalOpen3)
                                                                                }
                                                                            >
                                                                                <ModalHeader
                                                                                    toggle={() =>
                                                                                        setModalOpen3(!modalOpen3)
                                                                                    }
                                                                                >
                                                                                    PD(Left)
                                                                                </ModalHeader>
                                                                                <ModalBody>
                                                                                    {/* <h5>(-) Minus values</h5> */}
                                                                                    {[
                                                                                        "25.00",
                                                                                        "25.50",
                                                                                        "26.00",
                                                                                        "26.50",
                                                                                        "27.00",
                                                                                        "27.50",
                                                                                        "28.00",
                                                                                        "28.50",
                                                                                        "29.00",
                                                                                        "29.50",
                                                                                        "30.00",
                                                                                        "30.50",
                                                                                        "31.00",
                                                                                        "31.50",
                                                                                        "32.00",
                                                                                        "32.50",
                                                                                        "33.00",
                                                                                        "33.50",
                                                                                        "34.00",
                                                                                        "34.50",
                                                                                    ].map((value, index) => (
                                                                                        <Button
                                                                                            key={index}
                                                                                            outline="secondary"
                                                                                            style={{
                                                                                                margin: "5px",
                                                                                                width: "calc(15% - 10px)",
                                                                                            }}
                                                                                            onClick={() =>
                                                                                                handleSelectValue3(value)
                                                                                            }
                                                                                        >
                                                                                            {value}
                                                                                        </Button>
                                                                                    ))}
                                                                                </ModalBody>
                                                                                <ModalFooter>
                                                                                    {/* <Button color="light" onClick={() => setModalOpen(false)}>Cancel</Button> */}
                                                                                </ModalFooter>
                                                                            </Modal>
                                                                        </div>
                                                                    </CardBody>
                                                                </Card>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                        {/* <Row>
                      <Col md={6}>
                        <h3 className="font-size-25 mb-3">Review Your Order</h3>
                        <div className="review-section">
                          <p><strong>Frame Color:</strong> {addData.frame_color || "N/A"}</p>
                          <p><strong>Size:</strong> {addData.frame_size || "N/A"}</p>
                          <p><strong>Frame Material:</strong> {addData.frame_material || "N/A"}</p>
                          <p><strong>Frame Type:</strong> {addData.frame_type || "N/A"}</p>
                          <p><strong>Shape:</strong> {addData.frame_shape || "N/A"}</p>
                          <p><strong>Frame Brand:</strong> {addData.frame_brand || "N/A"}</p>
                          <p><strong>Tint:</strong> {addData.frame_brand || "N/A"}</p>
                          <p><strong>Lens Material:</strong> {addData.frame_brand || "N/A"}</p>
                        </div>
                      </Col>
                      <Col md={6}>
                        <h3 className="font-size-25 mb-3">Review Your Order</h3>
                        <div className="review-section">
                          <p>
                            <strong>{addData.lens_vision_name || "N/A"}:</strong>{" "}
                            {addData.lens_vision_type || "N/A"}
                          </p>
                          <p>
                            <strong>{addData.lens_type || "N/A"} Total:</strong> {selectedTotal}
                          </p>
                        </div>
                      </Col>
                    </Row> */}
                                        <Row className="g-2">
                                            <Col md={6} className="p-3 border rounded shadow-sm bg-light">
                                                <h3 className="font-size-25 mb-3 text-primary fw-bold">Review Your Order</h3>
                                                <div className="review-section">
                                                    <p className="mb-2"><strong>Frame Color:</strong> <span className="text-secondary">{addData.frame_color || "N/A"}</span></p>
                                                    <p className="mb-2"><strong>Size:</strong> <span className="text-secondary">{addData.frame_size || "N/A"}</span></p>
                                                    <p className="mb-2"><strong>Frame Material:</strong> <span className="text-secondary">{addData.frame_material || "N/A"}</span></p>
                                                    <p className="mb-2"><strong>Frame Type:</strong> <span className="text-secondary">{addData.frame_type || "N/A"}</span></p>
                                                    <p className="mb-2"><strong>Shape:</strong> <span className="text-secondary">{addData.frame_shape || "N/A"}</span></p>
                                                    <p className="mb-2"><strong>Frame Brand:</strong> <span className="text-secondary">{addData.frame_brand || "N/A"}</span></p>
                                                    <p className="mb-2"><strong>Tint:</strong> <span className="text-secondary">{addData.tint || "N/A"}</span></p>
                                                    <p className="mb-2"><strong>Lens Material:</strong> <span className="text-secondary">{addData.lens_material || "N/A"}</span></p>
                                                </div>
                                            </Col>

                                            <Col md={6} className="p-3 border rounded shadow-sm bg-light">
                                                <h3 className="font-size-25 mb-3 text-primary fw-bold">Final Total R:</h3>
                                                <div className="review-section">
                                                    <p className="mb-2">
                                                        <strong>{addData.lens_vision_name || "N/A"}:</strong> <span className="text-secondary">{addData.lens_vision_type || "N/A"}</span>
                                                    </p>
                                                    <p className="mb-2">
                                                        <strong>{addData.lens_type || "N/A"} Total:</strong> <span className="text-secondary">{selectedTotal}</span>
                                                    </p>
                                                </div>
                                            </Col>
                                        </Row>

                                        <hr
                                            style={{
                                                borderTop: "0.1px solid grey",
                                                margin: "20px 0",
                                            }}
                                        />
                                        {/* <Col md={3}>
                                            <div className="mb-3">
                                                <Label htmlFor="formrow-framecolor-Input">
                                                    Authorized By<span style={{ color: "red", fontWeight: "bolder" }}>*</span>
                                                </Label>
                                                <Input
                                                    type="text"
                                                    className="form-control"
                                                    name="authorized_by"
                                                    placeholder="Authorized By"
                                                    onChange={e => onValueChange(e)}
                                                />
                                            </div>
                                        </Col> */}
                                        {/* <Col md={3}>
                                            <div className="mb-3">
                                                <Label htmlFor="formrow-framecolor-Input">
                                                    Practice Name<span style={{ color: "red", fontWeight: "bolder" }}>*</span>
                                                </Label>
                                                <Input
                                                    type="text"
                                                    className="form-control"
                                                    name="practice_name"
                                                    placeholder="Practice Name"
                                                    onChange={e => onValueChange(e)}
                                                />
                                            </div>
                                        </Col> */}
                                        {/* <Col md={3}>
                                            <div className="mb-3">
                                                <Label htmlFor="formrow-framecolor-Input">
                                                    PX Number<span style={{ color: "red", fontWeight: "bolder" }}>*</span>
                                                </Label>
                                                <Input
                                                    type="text"
                                                    className="form-control"
                                                    name="px_number"
                                                    placeholder="PX Number"
                                                    onChange={e => onValueChange(e)}
                                                />
                                            </div>
                                        </Col> */}
                                        {/* <Col md={3}>
                                            <div className="mb-3">
                                                <Label htmlFor="formrow-framecolor-Input">
                                                    Additional notes:
                                                </Label>
                                                <Input
                                                    type="textarea"
                                                    className="form-control"
                                                    name="additional_notes"
                                                    placeholder="Additional notes"
                                                    onChange={e => onValueChange(e)}
                                                />
                                            </div>
                                        </Col> */}
                                    </Row>
                                    <Row>
                                        <Col md={3} style={{ display: "none" }}>
                                            <div className="mb-3">
                                                <Label htmlFor="digital-signature">
                                                    <b>Digital Signature</b>
                                                </Label>
                                                <div className="signature-container">
                                                    <SignatureCanvas
                                                        penColor="black"
                                                        canvasProps={{
                                                            width: 200,
                                                            height: 150,
                                                            className: "signature-canvas",
                                                            style: { border: "5px solid #ccc" },
                                                        }}
                                                        ref={ref => setSignatureRef(ref)}
                                                    />
                                                </div>
                                                <div className="mt-3">
                                                    <Button
                                                        onClick={clearSignature}
                                                        color="secondary"
                                                        style={{ marginRight: "18px" }}
                                                    >
                                                        Clear
                                                    </Button>
                                                    <Button
                                                        onClick={saveSignature}
                                                        color="primary"
                                                        style={{ marginRight: "18px" }}
                                                    >
                                                        Sign
                                                    </Button>
                                                    {signatureRef && (
                                                        <Button
                                                            onClick={() => alert("Done")}
                                                            color="success"
                                                        >
                                                            Done
                                                        </Button>
                                                    )}
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                    <div>
                                        <button
                                            className="btn btn-primary w-md mx-2"
                                            onClick={e => handleSubmit(e)}
                                        >
                                            Save
                                        </button>
                                    </div>
                                </Form>
                            </CardBody>
                        </Card>
                    </Row>
                </Container>
            </div>
        </React.Fragment >
    )
}

export default Onlineorder
